<template>
    <main class="page">
        <!-- Banner -->
        <!-- <motor-banner v-if="news" :bgimg="{
            src: env.imageUrl + news.image,
            loading: env.imageUrl + news.thumb_image,
        }" /> -->
        <section class="banner" v-if="news">
            <!-- <img src="../assets/images/test.jpg" alt=""> -->
            <img v-lazy="{
                src: env.imageUrl + news.image,
                loading: env.imageUrl + news.thumb_image,
            }" alt="">
        </section>
        <section class="section section--loading image" v-else>
        </section>
        <section class="section--news" v-if="news">
            <div class="motor-container">
                <article class="article">
                    <h1>{{news.title}}</h1>
                    <div class="info">
                        <div class="txt author">{{news.author}}</div>
                        <div class="devider"></div>
                        <div class="txt category">{{news.category}}</div>
                        <div class="devider"></div>
                        <div class="txt date">{{news.date | formatDate}}</div>
                    </div>
                    <p v-html="news.description"></p>
                    <div class="social-share">
                        <vue-goodshare-facebook 
                            button_design="gradient"
                            page_url="https://venuslab.co/blog/8" 
                            title_social="Facebook"
                            has_icon 
                            ></vue-goodshare-facebook>
                        <vue-goodshare-twitter 
                            button_design="gradient"
                            page_url="https://venuslab.co/blog/8" 
                            title_social="Twitter"
                            has_icon 
                            ></vue-goodshare-twitter>
                        <vue-goodshare-viber 
                            button_design="gradient"
                            page_url="https://venuslab.co/blog/8" 
                            title_social="Viber"
                            has_icon 
                            ></vue-goodshare-viber>
                        <vue-goodshare-line 
                            button_design="gradient"
                            page_url="https://venuslab.co/blog/8" 
                            title_social="Share"
                            has_icon 
                            ></vue-goodshare-line>
                    </div>
                </article>
                <aside class="aside">
                    <h2>Recent Posts</h2>
                    <ul class="recent-articles">
                        <li class="article" v-for="recent in recentNews" :key="recent.id">
                            <router-link :to="'/news/' + recent.id">
                                <h4>{{recent.title}}</h4>
                                <div class="info">
                                    <div class="txt author">{{news.author}}</div>
                                    <div class="devider"></div>
                                    <div class="txt category">{{news.category}}</div>
                                    <div class="devider"></div>
                                    <div class="txt date">{{news.date | formatDate}}</div>
                                </div>
                            </router-link>
                        </li>
                    </ul>
                </aside>
            </div>
        </section>
        <section class="section section--loading" v-else>
            <div class="loading--icon"></div>
        </section>
        <!-- Footer -->
        <motor-footer :data="main" />
    </main>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import MotorBanner from '@/components/MotorBanner.vue'
import BannerImg from '@/assets/images/home-banner.jpg'
import { env } from '../enviorments'

// Social Share
import VueGoodshareFacebook from 'vue-goodshare/src/providers/Facebook.vue'
import VueGoodshareTwitter from 'vue-goodshare/src/providers/Twitter.vue'
import VueGoodshareViber from 'vue-goodshare/src/providers/Viber.vue'
import VueGoodshareLine from 'vue-goodshare/src/providers/Line.vue'

export default {
    name: 'news-detail',
    components: {
        MotorBanner,
        VueGoodshareTwitter,
        VueGoodshareFacebook,
        VueGoodshareViber,
        VueGoodshareLine,
    },
    watch: {
        '$route'(to, from) {
            const id = to.params.id
            this.news = null
            this.callNewDatail(id).then(res => {
                this.news = res
            })
        }
    },
    data() {
        return {
            BannerImg,
            news: null,
            env,
        }
    },
    computed: {
        ...mapState({
            main: state => state.main,
            recentNews: state => state.recentNews,
        })
    },
    methods: {
        ...mapActions({
            callMain: 'callMain',
            callNewDatail: 'callNewDatail',
            callRecentNews: 'callRecentNews',
        })
    },
    async mounted() {
        const id = this.$route.params.id
        console.log(id)
        if (!this.main) await this.callMain()
        this.news = await this.callNewDatail(id)
        console.log(this.news)
        this.callRecentNews()
    },
}
</script>

<style lang="scss" scoped>
.page {
    .banner {
        margin-top: 90px;
        max-width: var(--max-width);
        margin: var(--header-height) auto 0;
        width: 100%;
        height: auto;
        img {
            width: 100%;
        }
    }
    .section--loading {
        height: 500px;
        display: flex;
        justify-content: center;
        align-items: center;
        &.image {
            height: 400px;
            max-height: 80vh;
            background-color: var(--primary);
            @media (min-width: 768px) {
                height: 600px;
            }
        }
    }
    .section--news {
        .motor-container {
            display: block;
            @media (min-width: 768px) {
                display: flex;
            }
            .article {
                width: calc(100% - 20px);
                max-width: initial;
                @media (min-width: 768px) {
                    flex: 3;
                }
                h1 {
                    font-weight: 900;
                    color: #555;
                    @media (min-width: 768px) {
                        font-size: 1.6rem;
                    }
                    @media (min-width: 992px) {
                        font-size: 1.8rem;
                    }
                }
                p {
                    font-size: 1rem;
                }
            }
            .aside {
                padding: 40px 10px;
                @media (min-width: 768px) {
                    flex: 1;
                }
                h2 {
                    font-weight: 300;
                    padding: 0;
                    color: var(--primary);
                    @media (min-width: 768px) {
                        font-size: 1.8rem;
                    }
                    @media (min-width: 992px) {
                        font-size: 2rem;
                    }
                }
                .recent-articles {
                    margin: 0;
                    padding: 0;
                    list-style: none;
                    .article {
                        width: 100%;
                        margin: 10px 0;
                        padding: 10px 0;
                        border-bottom: 1px solid var(--primary);
                        a {
                            color: initial;
                            text-decoration: none;
                            h4 {
                                color: #555;
                                padding-top: 0;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
